import i18n from 'i18nextInstance';
import moment from 'moment';
import { removePoint, uppercaseFirst } from 'shared/utils';

export const formats = {
    dayFormat: date => uppercaseFirst(removePoint(moment(date).format('ddd DD'))),
    dayHeaderFormat: date => uppercaseFirst(removePoint(moment(date).format('dddd DD [de] MMMM'))),
    dayRangeHeaderFormat: ({ end, start }) => {
        const endDay = moment(end);
        const startDay = moment(start);
        return `
            ${ uppercaseFirst(startDay.format('MMMM DD')) } - 
            ${ !endDay.isSame(startDay, 'month') ? `${ uppercaseFirst(endDay.format('MMMM')) } ` : '' }${ endDay.format('DD') }`;
    },
    eventTimeRangeFormat: () => '',
    monthHeaderFormat: date => uppercaseFirst(moment(date).format('MMMM - YYYY')),
    weekdayFormat: date => uppercaseFirst(removePoint(moment(date).format('ddd')))
};

export const messages = {
    agenda: i18n.t('Agenda'),
    allDay: i18n.t('Todo el día'),
    date: i18n.t('Fecha'),
    day: i18n.t('Día'),
    event: i18n.t('Paciente'),
    month: i18n.t('Mes'),
    next: '>',
    noEventsInRange: i18n.t('No hay turnos para este rango'),
    previous: '<',
    showMore: total => `${ i18n.t('y') } ` + total + ` ${ i18n.t('más') }`,
    time: i18n.t('Horario'),
    today: i18n.t('Hoy'),
    week: i18n.t('Semana')
};
